import brace from 'brace'

/**
 * @description Utility function to set certain sections of the ace editor to readonly
 * @param {Object} editor - instantiated ace editor object
 * @param {Array} readonly_ranges - Array of arrays, each element contains 4 integers representing a range, eg [[start_row,start_col,end_row,end_col]]
 */
export default function setReadonly(editor,readonly_ranges) {
    var session  = editor.getSession()
    var Range    = brace.acequire('ace/range').Range
    var ranges    = []
    function before(obj, method, wrapper) {
      var orig = obj[method];
      obj[method] = function() {
        var args = Array.prototype.slice.call(arguments);
        return wrapper.call(this, function(){
            return orig.apply(obj, args);
        }, args);
      }
      return obj[method];
    }
    function intersects(range) {
        return editor.getSelectionRange().intersects(range);
    }
    function intersectsRange(newRange) {
      for (let i=0;i<ranges.length;i++)
        if(newRange.intersects(ranges[i]))
          return true;
      return false;
    }
    function preventReadonly(next, args) {
        for(let i=0;i<ranges.length;i++){if (intersects(ranges[i])) return;}
        next();
    }
    function onEnd(position){
      var row = position["row"],column=position["column"];
      for (let i=0;i<ranges.length;i++)
        if(ranges[i].end["row"] === row && ranges[i].end["column"]===column)
          return true;
      return false;
    }
    function outSideRange(position){
      var row = position["row"],column=position["column"];
      for (let i=0;i<ranges.length;i++){
        if(ranges[i].start["row"]< row && ranges[i].end["row"]>row)
            return false;
        if(ranges[i].start["row"]===row && ranges[i].start["column"]<column){
            if(ranges[i].end["row"] !== row || ranges[i].end["column"]>column)
              return false;
        }
        else if(ranges[i].end["row"] === row&&ranges[i].end["column"]>column){
              return false;
        }
      }
      return true; 
    }
    for(let i=0;i<readonly_ranges.length;i++){
        ranges.push(new Range(...readonly_ranges[i]));
    }
    ranges.forEach(function(range){session.addMarker(range, "readonly-highlight");});
    session.setMode("ace/mode/javascript");
    editor.keyBinding.addKeyboardHandler({
        handleKeyboard : function(data, hash, keyString, keyCode, event) {
          if (Math.abs(keyCode) === 13 && onEnd(editor.getCursorPosition())){
            return false;
          }
          if (hash === -1 || (keyCode <= 40 && keyCode >= 37)) return false;
          for(let i=0;i<ranges.length;i++){
            if (intersects(ranges[i])) {
                return {command:"null", passEvent:false};
            }
          }
        }
    });
    before(editor, 'onPaste', preventReadonly);
    before(editor, 'onCut',   preventReadonly);
    for(let i=0;i<ranges.length;i++){
      ranges[i].start = session.doc.createAnchor(ranges[i].start);
      ranges[i].end = session.doc.createAnchor(ranges[i].end);
      ranges[i].end.$insertRight = true;
     }

    var old$tryReplace = editor.$tryReplace;
    editor.$tryReplace = function(range, replacement) {
        return intersectsRange(range)?null:old$tryReplace.apply(this, arguments);                        
    }
    
    var oldInsert = session.insert;
    session.insert = function(position, text) {
        return oldInsert.apply(this, [position, outSideRange(position)?text:""]);
    }
    var oldRemove = session.remove;
    session.remove = function(range) {
        return intersectsRange(range)?false:oldRemove.apply(this, arguments);                        
    }
    var oldMoveText = session.moveText;
    session.moveText = function(fromRange, toPosition, copy) {
        if (intersectsRange(fromRange) || !outSideRange(toPosition)) return fromRange;
        return oldMoveText.apply(this, arguments);
    }
}


// WEBPACK FOOTER //
// ./src/components/utilities/functions/AceEditorReadOnly.js